import * as React from 'react';
import {
  Container,
  Box,
  ListItemText,
  ListSubheader,
  List,
  ListItemButton,
  Typography,
  Button
} from '@mui/material';
import fetchDiscussions from '../helper-methods/fetchDiscussions';
import useStore from '../state-files/zustondStoreStates';
import extractChatMessages from '../helper-methods/fetchAndRefreshMessages';
import useMessagesStore from '../state-files/useMessagesStore';
import CreateDiscussionWidget from './CreateDiscussionWidget';
import Review from '../Components/Review';
import CommunityDiscussionComponent from '../Components/CommunityDiscussionComponent';
import { apiUrlBase, apiUrlPrefix } from '../../../config';
import { useMediaQuery } from "@mui/system";
import DeleteIcon from '@mui/icons-material/Delete';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DownloadApps from '../Components/Mobile/DownloadApps';
import HeaderBar from '../Components/Static/HeaderBar';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import MobileSidebar from '../Components/Sidebar/MobileSidebar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';

const DiscussionScreen = () => {
  const { setCurrentDiscussionId, discussions, setDiscussions, subscriptionData, setSubscriptionData,greenButtonSX, nonCommunityDiscussions } = useStore();
  const { setMessageList } = useMessagesStore();
  const { currentCommunityId, discussionPressed, setDiscussionPressed, setChatId } = useStore(); // Use zustand store
  const isMobile = useMediaQuery('(max-width:1300px)');
  const [currentUser] = React.useState(localStorage.getItem('userId'));
  const [removedDiscussions, setRemovedDiscussions] = React.useState({});
  const navigate = useNavigate();
  const [notificationsEnabled, setNotificationsEnabled] = React.useState(false);
  const [subscribed, setSubscribed] = React.useState(false);
  const [unsubscribedDiscussions, setUnsubscribedDiscussions] = React.useState({});

  React.useEffect(() => {
    if (discussionPressed) {
      setDiscussions(nonCommunityDiscussions);
      setDiscussionPressed(false);
    }

  }, [discussionPressed]);

  const fetchChatMessages = async (discussionId) => {
    setChatId(discussionId);
    setMessageList(extractChatMessages(discussionId, currentCommunityId));
    navigate('/chat');
  };

  const deleteDiscussion = async ({ discussionId }) => {

    const apiUrl = apiUrlPrefix + `Discussion/RemoveDiscussion/${discussionId}`;
    const response = await fetch(apiUrl, {
      method: 'Delete',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.ok) {
      return response.status;
    } else if (response.status === 304 || response.status === 400) {
      return 304; //It is not modified
    }
  }

  // Add this helper function outside your component or at the top of the file
  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  // Inside your subscribeUser function:
  const subscribeUser = async () => {
    const registration = await navigator.serviceWorker.ready;
    // Convert your string key to the format the browser actually wants
    const convertedVapidKey = urlBase64ToUint8Array('BBgNon8jRO_vOU4ajOWOKbcdNCeLPW1zYMYPEqhJq6a-RmjJp5aT-6z_kJ5jbe0uNupmzd1Ev4vGysrAPQ_Djo0');

    await navigator.serviceWorker.ready; // <---------- WAIT

    if (!registration.pushManager) {
      alert("PushManager not found. Are you sure this is added to Home Screen via Safari?");
      return;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    const subscriptionData = subscription.toJSON();

    setSubscriptionData(subscriptionData);
  }

  const enableNotifications = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      setNotificationsEnabled(true);
      alert("Success! Now enable push notifications");
      // Now proceed to save subscription to DB
    } else {
      alert("Permission denied. You'll need to go to Safari settings or 'Clear History' to reset this.");
    }

    subscribeUser();
  }

  const handleSubscribe = async () => {

    if (!subscriptionData) {
      alert("No subscription data found. Is the Service Worker registered?");
      return;
    }
    try {
      const res = await fetch(`${apiUrlBase}Notifications/save-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        },
        body: JSON.stringify({
          endpoint: subscriptionData.endpoint,
          expirationTime: subscriptionData.expirationTime,
          keys: {
            p256dh: subscriptionData.keys.p256dh,
            auth: subscriptionData.keys.auth
          }
        }),
      });

      if (res.ok) {
        alert("You now receive notifications");
        localStorage.setItem('isSubscribed', true);
        setSubscribed(true);
      }
      else {
        alert("Unknown error occurred: " + res.status);
      }
    } catch (err) {
      console.error("Failed to save subscription:", err);
    }
  };

  const unsubscribeFromChat = async (discussionId) => {

    if (!subscriptionData) {
      alert("No subscription data found. Is the Service Worker registered?");
      return;
    }
    try {
      const res = await fetch(`${apiUrlBase}Notifications/unsubscribe-discussion`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        },
        body: JSON.stringify({
          id: discussionId,
        }),
      });

      if (res.ok) {
      }
      else {
        alert("Unknown error occurred: " + res.status);
      }
    } catch (err) {
      console.error("Failed to save subscription:", err);
    }
  };

  const subscribeToChat = async (discussionId) => {

    if (!subscriptionData) {
      alert("No subscription data found. Is the Service Worker registered?");
      return;
    }
    try {
      const res = await fetch(`${apiUrlBase}Notifications/subscribe-to-discussion`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        },
        body: JSON.stringify({
          id: discussionId,
        }),
      });

      if (res.ok) {
      }
      else {
        alert("Unknown error occurred: " + res.status);
      }
    } catch (err) {
      console.error("Failed to save subscription:", err);
    }
  };


  /*

    Component code

  */
  return (
    <Box
      sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
    >
      <HeaderBar isLoggedIn={true} />
      {/* Add this button specifically for your users to trigger the flow */}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'flex-start' }}>
        <Sidebar />
        <MobileSidebar />
        <Container>
          {/* This is used to manage the header component when a user clicks a community, this will not appear if they are just in the discussions tab */}
          <CommunityDiscussionComponent />
          <p></p>
          <Button sx={[greenButtonSX, {width: '100%', p: 1, marginBottom: 1}]} 
          className={(localStorage.getItem('isSubscribed') === 'true' || notificationsEnabled === true) ? 'hidden' : ''}
            onClick={() => {
              enableNotifications();
            }}
          >
            Allow notifications
          </Button>
          <Button sx={[greenButtonSX, {width: '100%', p: 1, marginBottom: 1}]} 
          className={(subscribed === true || notificationsEnabled === false) ? 'hidden' : ''}
            onClick={() => {
              handleSubscribe();
            }}
          >
            Enable Push Notifications
          </Button>
          <List
            sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: '5px', boxShadow: 1 }}
            component="nav"
            subheader={
              <ListSubheader
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  py: 1,
                  borderBottom: '1px solid #eee'
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Discussions
                </Typography>
                <p />

                {/* Create Discussion button */}
                <Typography variant="subtitle1" sx={greenButtonSX}>
                  <CreateDiscussionWidget isBold={true} />
                </Typography>


                {/* Place the actual widget here so it can listen for the state change */}

              </ListSubheader>
            }
          >
            {discussions
              .sort((a, b) => {
                const priorityId = "69769ec2f601532a29c0a0a3"; //This is the introduction channel

                // 1. If 'a' is the priority ID, move it to the top
                if (a.id === priorityId) return -1;
                // 2. If 'b' is the priority ID, move it to the top
                if (b.id === priorityId) return 1;

                // 3. Otherwise, sort the rest alphabetically by title
                return (a.title || "").localeCompare(b.title || "");
              })
              .map((discussion, index) => {
                const isChatAdmin = discussion?.admins?.includes(currentUser);
                const wantsToDeleteDiscussion = removedDiscussions[discussion.id];
                // ✅ DERIVED STATE: No 'setUnsubscribedDiscussions' needed here!
                // This variable is calculated fresh every time the list renders.
                // Use square brackets to look up the ID, and !! to force it to a boolean
                var isUnsubscribed = unsubscribedDiscussions[discussion.id];
                if(!unsubscribedDiscussions[discussion.id]) {
                  isUnsubscribed = discussion?.unsubscribedUsers?.includes(currentUser);
                }
                
                return (
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', gap: 3 }}>
                    <ListItemButton key={discussion.id || index} onClick={() => fetchChatMessages(discussion.id)} sx={{ display: 'flex', justifyContent: { md: 'space-between' }, flexGrow: 1 }}>
                      <ListItemText
                        primary={discussion.title || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                    </ListItemButton>

                    <Typography className={localStorage.getItem('isSubscribed') === 'true' ? '' : 'hidden'} sx={{ color: 'blue', cursor: 'pointer', pr: isChatAdmin ? '' : 3 }} onClick={() => {
                      if (isUnsubscribed) {
                        subscribeToChat(discussion.id);
                        setUnsubscribedDiscussions(prev => {
                          const { [discussion.id]: deletedItem, ...rest } = prev;
                          return rest; // This 'rest' becomes the new state
                        });
                        return;
                      }
                      unsubscribeFromChat(discussion.id);
                      setUnsubscribedDiscussions(prev => ({
                        ...prev,
                        [discussion.id]: true
                      }));
                    }}> {isUnsubscribed ? <NotificationsOffIcon /> : <NotificationsActiveIcon />} </Typography>

                    <Typography component={Link} to="/moderationPanel" sx={{ display: isChatAdmin ? 'flex' : 'none', color: 'blue', cursor: 'pointer' }} onClick={() => {
                      setCurrentDiscussionId(discussion.id);
                    }}><ManageAccountsIcon /></Typography>

                    <Typography sx={{ display: isChatAdmin ? 'flex' : 'none', color: 'red', pr: 3, cursor: 'pointer' }} onClick={() => {
                      if (!wantsToDeleteDiscussion) {
                        setRemovedDiscussions(prev => ({
                          ...prev,
                          [discussion.id]: true //Mark this as wanting to delete
                        }));
                        return;
                      } else {
                        // Inside your delete function
                        deleteDiscussion({ discussionId: discussion.id }); //Remove the community from the server

                        const newDiscussions = discussions.filter((discussions) => discussions.id !== discussion.id);

                        // Use the functional update to ensure you have the current state
                        setDiscussions(newDiscussions);
                      }
                    }}>{(wantsToDeleteDiscussion) ? "Confirm" : <DeleteIcon />}</Typography>
                  </Box>
                )
              })}
          </List>

          <Review />
        </Container>
      </Box>
    </Box>
  );
};

export default DiscussionScreen;